export const STATUS_OPTIONS = [
    { label: 'Unpaid', value: 'unpaid' },
    { label: 'Paid', value: 'paid' },
];

export const FULLFILLMENT_OPTIONS = [
    { label: 'Pending', value: 'pending' },
    { label: 'Complete', value: 'complete' },
];
